import React, { useEffect, useState, useRef } from 'react';
import { Container, Table, Spinner, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useDispatch, useSelector } from 'react-redux';
import { Get_Developer_Statement_Action } from '../Redux/Actions/Commission_pay_Action';

import { FormControl, InputLabel, Select, MenuItem, Box, useTheme } from '@mui/material';
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';

export const DeveloperAccountsPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme(); // 📌 عشان نجيب الثيم الحالي

  const tableRef = useRef();

  const [selectedDevId, setSelectedDevId] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  useEffect(() => {
    dispatch(GetDevelopersData());
  }, [dispatch]);

  useEffect(() => {
    if (selectedDevId) {
      dispatch(Get_Developer_Statement_Action(selectedDevId));
    }
  }, [selectedDevId, dispatch]);

  const resdeveloperstatement = useSelector(
    (state) => state.AllCommission_Pays.Get_Developer_Statement,
  );
  const developersList = useSelector((state) => state.AllDevelopers?.Developers?.data || []);

  const loading = resdeveloperstatement?.loading;
  const error = resdeveloperstatement?.error;
  const data = resdeveloperstatement || {};
  const statement = Array.isArray(data.statement) ? data.statement : [];

  const filteredStatement = statement.filter((item) => {
    if (!fromDate && !toDate) return true;
    const paymentDates = item.payments?.map((p) => new Date(p.date)) || [];
    const latestPayment = paymentDates.length > 0 ? Math.max(...paymentDates) : null;
    if (!latestPayment) return true;

    const from = fromDate ? new Date(fromDate) : null;
    let to = toDate ? new Date(toDate) : null;
    if (to) to.setHours(23, 59, 59, 999);

    if (from && to) return latestPayment >= from && latestPayment <= to;
    if (from) return latestPayment >= from;
    if (to) return latestPayment <= to;

    return true;
  });

  const exportToExcel = () => {
    let csv = 'Project,Lead,Unit Price,Commission,Paid,Remaining\n';
    filteredStatement.forEach((item) => {
      csv += `${item.project},${item.lead},${item.unitPrice},${item.commissionValue},${item.paid},${item.remaining}\n`;
    });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'developer_statement.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <Container className="startpage" style={{ color: theme.palette.text.primary }}>
      <Link
        to={`/LeadsForAccountant`}
        style={{
          textDecoration: 'none',
          color: theme.palette.mode === 'dark' ? '#90caf9' : '#0F7687',
        }}
      >
        <span style={{ fontWeight: 'bold' }}>Home</span>
      </Link>{' '}
      <KeyboardDoubleArrowRightIcon /> <span>Developer Account Statement</span>
      <hr />
      <Box sx={{ minWidth: 250, mb: 4 }}>
        <FormControl fullWidth>
          <InputLabel>Choose Developer</InputLabel>
          <Select
            value={selectedDevId}
            label="Choose Developer"
            onChange={(e) => setSelectedDevId(e.target.value)}
          >
            {developersList.map((dev) => (
              <MenuItem key={dev._id} value={dev._id}>
                {dev.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {selectedDevId && (
        <div className="my-3">
          <strong>Statement For Developer ID:</strong> {selectedDevId}
        </div>
      )}
      {selectedDevId && (
        <>
          <Row className="mb-3">
            <Col md={3}>
              <label>From:</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <label>To:</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Col>
            <Col md={6} className="d-flex align-items-end justify-content-end gap-2">
              <button className="btn btn-success" onClick={exportToExcel}>
                📥 Export Excel
              </button>
              <button className="btn btn-primary" onClick={handlePrint}>
                🖨️ Print PDF
              </button>
            </Col>
          </Row>

          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="info" />
            </div>
          ) : error ? (
            <Alert variant="danger">{error}</Alert>
          ) : (
            <>
              <Row className="mb-4">
                <Col>
                  <strong>Total Commission:</strong> {data.totalCommission?.toLocaleString() || 0}{' '}
                  AED
                </Col>
                <Col>
                  <strong>Total Paid:</strong> {data.totalPaid?.toLocaleString() || 0} AED
                </Col>
                <Col>
                  <strong>Remaining:</strong> {data.totalRemaining?.toLocaleString() || 0} AED
                </Col>
              </Row>

              <div ref={tableRef}>
                {filteredStatement.length > 0 ? (
                  <Table
                    striped
                    bordered
                    hover
                    responsive
                    variant={theme.palette.mode === 'dark' ? 'dark' : 'light'}
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Project</th>
                        <th>Lead</th>
                        <th>Unit Price</th>
                        <th>Commission</th>
                        <th>Paid</th>
                        <th>Remaining</th>
                        <th>Payments</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredStatement.map((item, index) => (
                        <tr key={item.commissionId}>
                          <td>{index + 1}</td>
                          <td>{item.project}</td>
                          <td>{item.lead || '-'}</td>
                          <td>{item.unitPrice?.toLocaleString()} AED</td>
                          <td>{item.commissionValue?.toLocaleString()} AED</td>
                          <td>{item.paid?.toLocaleString()} AED</td>
                          <td>{item.remaining?.toLocaleString()} AED</td>
                          <td>
                            <ul className="mb-0">
                              {item.payments?.length > 0 ? (
                                item.payments.map((pay, idx) => (
                                  <li key={idx}>
                                    {new Date(pay.date).toLocaleDateString()} -{' '}
                                    {pay.amount.toLocaleString()} AED
                                  </li>
                                ))
                              ) : (
                                <span>No Payments</span>
                              )}
                            </ul>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <Alert variant="info">No statement data available for this developer.</Alert>
                )}
              </div>
            </>
          )}
        </>
      )}
    </Container>
  );
};
